"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
exports.ACLModule__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var ethers_1 = require("ethers");
var _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                indexed: false,
                internalType: "address",
                name: "deviceKey",
                type: "address"
            },
        ],
        name: "DeviceKeyRegistered",
        type: "event"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            },
        ],
        name: "accountToACL",
        outputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "factory",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "address",
                name: "signer",
                type: "address"
            },
        ],
        name: "isDeviceKey",
        outputs: [
            {
                internalType: "bool",
                name: "res",
                type: "bool"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "address",
                name: "deviceKey",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "signature",
                type: "bytes"
            },
        ],
        name: "registerDeviceKey",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "address",
                name: "deviceKey",
                type: "address"
            },
        ],
        name: "removeDeviceKey",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "userOpHash",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "userOpSignature",
                type: "bytes"
            },
        ],
        name: "validateSigner",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
];
var _bytecode = "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";
var isSuperArgs = function (xs) { return xs.length > 1; };
var ACLModule__factory = /** @class */ (function (_super) {
    __extends(ACLModule__factory, _super);
    function ACLModule__factory() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = this;
        if (isSuperArgs(args)) {
            _this = _super.apply(this, args) || this;
        }
        else {
            _this = _super.call(this, _abi, _bytecode, args[0]) || this;
        }
        return _this;
    }
    ACLModule__factory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    ACLModule__factory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    ACLModule__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    ACLModule__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    ACLModule__factory.createInterface = function () {
        return new ethers_1.utils.Interface(_abi);
    };
    ACLModule__factory.connect = function (address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    };
    ACLModule__factory.bytecode = _bytecode;
    ACLModule__factory.abi = _abi;
    return ACLModule__factory;
}(ethers_1.ContractFactory));
exports.ACLModule__factory = ACLModule__factory;
